import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        addNode: COMMON.en.addNode,
        options: 'Options',
        walkthrough: COMMON.en.walkthrough,
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out'
    }
}

export default TRANSLATIONS